module.exports = __webpack_public_path__ + "media/images/Metal-Bar-Rustic-1920px-cefb64bcad3ba20630e4b4dc64dda476.png";